<div #totalBar class="progress-background">
  <div #progressBar class="progress-indicator"></div>
</div>
